import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-goTop",
  "use": "icon-goTop-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" id=\"icon-goTop\">\n  <path d=\"M2.99854 4.49829H20.9985V2.99829H2.99854V4.49829Z\" fill=\"black\" fill-opacity=\"0.9\" />\n  <path d=\"M5.06534 15.3439L11.2299 9.29309L11.23 22.2656L12.7463 22.2655L12.7462 9.28509L19.0168 15.4007L20.0873 14.35L12.3366 6.79084C12.142 6.601 11.8313 6.6015 11.6373 6.79195L3.99149 14.2966L5.06534 15.3439Z\" fill=\"black\" fill-opacity=\"0.9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol